import React from 'react';
import style from './groupings-list.module.scss';
import FabIcon from '../../../../../../../assets/svg/solo-chat/fab.svg';
import { Group } from './group';
import { useQuery, useAppAndBranchId, usePermissions } from '../../../hooks';
import { api } from '../api';
import { Group as TGroup, Entity } from '../types';
import { Spinner } from '../../../../../../../helpers/commonUi';
import { EmptyGroup } from './EmptyGroup';

type Props = {
	intentId: string;
  entities: Entity[] | null
};

export function GroupingsList(props: Props) {
  const canCreate = usePermissions('nlu.Create')
	const [appId, branchId] = useAppAndBranchId();
	const { intentId, entities } = props;
	const {
		data: groups,
		setData: setGroups,
		refetch,
    loading,
	} = useQuery(
		() => api.getGroups(appId, branchId, intentId),
		intentId + branchId, // revalidate this query whenever `intentId` or `branchId` changes
		intentId.length !== 0,
	);

	function updateGroupById(id: string, group: TGroup) {
		setGroups((prev) => {
			const groups = Array.isArray(prev) ? [...prev] : [];
			return groups.map((item) => (item.id === id ? group : item));
		});
	}

	function removeGroupById(id: string) {
		setGroups((prev) => {
			const groups = Array.isArray(prev) ? [...prev] : [];
			return groups.filter((group) => group.id !== id);
		});
	}

  function addGroup() {
    setGroups(prev => {
      let groups = Array.isArray(prev) ? [...prev] : []
      const groupId = groups.length + 1
      groups = [{
        id: groupId.toString() + ":state",
        name: "Untitled",
        entities: [],
        utterances: [],
      }, ...groups]
      return groups
    })
  }

  if(loading) {
    return <Spinner />
  }

  return (
    <div className={style.groupingsList} data-loading={loading}>
      {intentId && groups?.length === 0 && (
        <EmptyGroup add={addGroup} canCreate={canCreate as boolean} />
      )}
      <div className={style.groups}>
        {intentId && groups?.map(group => {
          return <Group 
             entitiesData={entities}
             removeGroupById={removeGroupById} 
             refetchGroups={refetch} 
             key={group.id} 
             group={group} 
             intentId={intentId} 
             updateGroupById={updateGroupById} 
          />
        })}
      </div>
      {canCreate && (groups && groups.length > 0) &&
        <button onClick={addGroup} className={style.fab}>
          <img src={FabIcon} alt="fab" />
        </button>
      }
    </div>
  )
}
